import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useToast } from '@/hooks/useToast';
import { deleteJob } from '@/server/jobs.functions';

export const useDeleteJob = () => {
  const queryClient = useQueryClient();
  const { push } = useToast();

  return useMutation({
    mutationFn: (jobId: number) => deleteJob({ data: { id: jobId } }),
    onError: (error: Error) => push(error.message || 'Delete failed', 'error'),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['jobs'] });
      queryClient.invalidateQueries({ queryKey: ['stats'] });
    },
  });
};
